module.exports = __webpack_public_path__ + "img/1579071339.abf99c50.jpg";